import { ArrowNarrowUpIcon, ArrowNarrowDownIcon } from '@heroicons/react/solid';
import cx from 'classnames';

export type VisibilityDeltaProps = {
  current: number;
  previous?: number | null;
  className?: string;
};

function getDeltaClass(delta: number) {
  if (delta > 0) return 'yst-text-green-600';
  if (delta < 0) return 'yst-text-red-600';
  return 'yst-text-slate-500';
}

export default function VisibilityDelta({ current, previous, className }: VisibilityDeltaProps) {
  if (typeof previous !== 'number') {
    return null;
  }
  const delta = current - previous;
  const isPositive = delta > 0;
  const isNegative = delta < 0;
  const formattedDelta = `${delta > 0 ? '+' : ''}${delta.toFixed(1)}%`;

  return (
    <div
      className={cx(
        'yst-flex yst-items-center yst-gap-1 yst-text-tiny yst-font-bold',
        getDeltaClass(delta),
        className,
      )}
      aria-label={
        isPositive
          ? `Visibility increased by ${formattedDelta}`
          : isNegative
            ? `Visibility decreased by ${formattedDelta}`
            : 'No change in visibility'
      }
    >
      {isPositive && <ArrowNarrowUpIcon className="yst-w-4 yst-h-4" />}
      {isNegative && <ArrowNarrowDownIcon className="yst-w-4 yst-h-4" />}
      {formattedDelta}
    </div>
  );
}

